import { render } from "./home-page.vue?vue&type=template&id=98a16b02&ts=true"
import script from "./home-page.vue?vue&type=script&lang=ts"
export * from "./home-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__